<template>
  <div class="wrapper fill-vh">
    <div class="heading">
      <h1>Valitse kokeiltava kuntosali</h1>
    </div>
    <div class="club-cards-wrapper">
      <ClubCard v-for="club in allClubs" :key="club.id" v-bind:club="club" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import ClubCard from "@/components/ClubCard";
import { mapGetters } from "vuex";

export default {
  components: {
    ClubCard
  },
  computed: mapGetters(["allClubs"])
};
</script>

<style scoped>
@media (min-width: 601px) {
  .club-cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}
@media (min-width: 1025px) {
  .club-cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }
}
</style>
